import { useEffect, useState } from "react";
import Layout from "../../../Frames/Layout";
import { useNavigate, useParams } from "react-router-dom";
import API from "../../../../services/API";
import Loader from "../../../Tools/Loader";
import { Alert, InputAdornment, MenuItem, Stack, TextField, Typography } from "@mui/material";
import Rpps from "../../../Inputs/Rpps";
import { LoadingButton } from "@mui/lab";
import { Euro } from "@mui/icons-material";

export default function Form(){

    const {sessionId} = useParams()

    const [status, setStatus] = useState('loading')

    const [session, setSession] = useState({})

    const [data, setData] = useState({contribution: ''})

    const navigate = useNavigate()

    const [registrant, setRegistrant] = useState({
        firstName: '',
        lastName: '',
        email: '',
        rpps: '',
        gender: 'M',
        profession: '',
        speciality: ''
    })

    useEffect(() => {

        API.get(`/dpc/sessions/${sessionId}`)
            .then(r => {
                console.log(r.data)
                setSession(r.data)
                setStatus('ready')
            })
            .catch(e => setStatus('error'))

    }, [sessionId])

    const handleSubmit = e => {
        e.preventDefault()

        setStatus('submit')

        let registration = {...data, registrant, session}

        API.post(`/dpc/registrations`, registration)
            .then(r => {
                console.log(r.data)
                navigate(`/dpc/sessions/${sessionId}/registrations`)
            })
            .catch(e => {
                console.log(e.response?.data)
                setStatus('fail')
            })
    }

    return <Layout title="Inscriptions DPC" tab="sessions" menu="dpc" back={true}>
        
        {['ready','submit','fail'].includes(status) && 

            <form onSubmit={handleSubmit}>

                <Stack sx={{maxWidth: 500, margin: 'auto'}} spacing={3}>

                    <Typography><b>Session {session.number} |</b> {session.action?.title}</Typography>

                    <Typography variant='h4'>Inscription manuelle</Typography>

                    {status === 'fail' && 
                        <Alert severity='error'>Une erreur s'est produite. Vérifiez les informations.</Alert>
                    }

                    <TextField 
                        label="Nom"
                        value={registrant.lastName}
                        onChange={e => setRegistrant({...registrant, lastName: e.target.value})}
                        required
                        inputProps={{maxLength: 100}}
                        size='small'
                    />

                    <TextField 
                        label="Prénom"
                        value={registrant.firstName}
                        onChange={e => setRegistrant({...registrant, firstName: e.target.value})}
                        required
                        inputProps={{maxLength: 100}}
                        size='small'
                    />

                    <TextField 
                        label="Genre"
                        value={registrant.gender}
                        onChange={e => setRegistrant({...registrant, gender: e.target.value})}
                        required
                        size='small'
                        select
                    >
                        <MenuItem value='M'>Homme</MenuItem>
                        <MenuItem value='F'>Femme</MenuItem>
                    </TextField>

                    <TextField 
                        label="Email"
                        value={registrant.email}
                        onChange={e => setRegistrant({...registrant, email: e.target.value})}
                        required
                        inputProps={{maxLength: 100}}
                        size='small'
                    />

                    <Rpps 
                        value={registrant.rpps}
                        onChange={rpps => setRegistrant({...registrant, rpps})}
                        required
                    />

                    <TextField 
                        label="Profession"
                        value={registrant.profession}
                        onChange={e => setRegistrant({...registrant, profession: e.target.value})}
                        inputProps={{maxLength: 100}}
                        size='small'
                    />

                    <TextField 
                        label="Spécialité"
                        value={registrant.speciality}
                        onChange={e => setRegistrant({...registrant, speciality: e.target.value})}
                        inputProps={{maxLength: 100}}
                        size='small'
                    />

                    <TextField 
                        label="Montant de la participation"
                        type="number"
                        value={data.contribution}
                        onChange={e => setData({...registrant, contribution: e.target.value})}
                        required
                        inputProps={{step: 0.01, min: 0, max: 10000}}
                        InputProps={{
                            endAdornment: <InputAdornment position='end'>
                                <Euro/>
                            </InputAdornment>,
                        }}
                        size='small'
                    />

                    <LoadingButton
                        loading={status === 'submit'}
                        type='submit'
                        variant='contained'
                    >
                        Valider
                    </LoadingButton>
                    
                </Stack>
        
            </form>
        }

        {status === 'loading' && <Loader />}

        {status === 'error' && 
            <Alert severity='error'>Une erreur s'est produite.</Alert>
        }

    </Layout>
}